import { useTimer } from '@hooks/client';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';

import {
  CardSellerInfoEntity,
  CardSellerItemEntity,
  CardSellerItemsWrapper,
  CardSellersWrapper,
} from '@/entities';
import { InventoryItem } from '@/shared/types/common';
import {
  Button,
  Description,
  Illustration,
  IllustrationModal,
  ModalContent,
  TagInfo,
} from '@/shared/ui';
import { useStore } from '@/store/context';
import { Trade } from '@/store/items-withdrawal/items-withdrawal';

import styles from './pickup-items.module.scss';

export const PickUpItemsFeature = observer(({ trade }: { trade: Trade }) => {
  const withdrawal = useStore()?.withdrawal;

  const handleGuideOpen = () => {
    withdrawal?.setGuideStep(1);
    withdrawal?.setSelectedTrade(null);
  };

  return (
    <>
      <ModalContent.Title
        className={styles['title']}
        title={'Pick up items'}
        subtitle={'Item withdrawal'}
      />
      <Button
        variant="secondary"
        onClick={handleGuideOpen}
        iconLeft={<Illustration name="question-square" spriteName="icons" />}
        width="content"
        className={styles['guide-button']}
      />
      <ModalContent.Body className={styles['body']}>
        <IllustrationModal variant={'pick-up-items'} />
        <Description
          className={styles['description']}
          message={`Go to the seller ${trade.linkedRobloxAccount.robloxAccountName} and collect the items. He will be waiting at his home. Use the teleport`}
        />
        {Array.isArray(trade.items) && trade.items?.length > 0 && (
          <CardSellerItemsWrapper>
            {trade.items?.map(item => {
              return (
                <CardSellerItemEntity
                  key={`CardSellerItemEntity-${item.id}`}
                  item={item}
                />
              );
            })}
          </CardSellerItemsWrapper>
        )}
      </ModalContent.Body>

      <ModalContent.Footer>
        <ModalContent.Button
          variant={'primary'}
          text={'Go to server'}
          onClick={() => {
            withdrawal?.updateTradeStatus('success');
          }}
        />
      </ModalContent.Footer>
    </>
  );
});
